import { useState } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import SaveIcon from "@mui/icons-material/Save";
import { Progress } from "react-sweet-progress";
import "react-sweet-progress/lib/style.css";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { NumericFormat } from "react-number-format";
import Alert from "@mui/material/Alert";
import Task from "../model/Task";

export default function DistributionForm({ task, isButtonVisible }) {
  const [distribution, setDistribution] = useState([]);
  const [totalProgress, setTotalProgress] = useState(0);
  const [correct, setCorrect] = useState(false);
  const [open, setOpen] = useState(false);
  const [progress, setProgress] = useState("active");
  const isTask = task instanceof Task;

  const handleOpen = () => {
    const planned = task.plannedProgress.map((x) => x.expectedProgress);
    setDistribution(planned);

    const progressNum = planned.reduce(function (a, b) {
      return a + b;
    }, 0);

    setTotalProgress(progressNum);
    setCorrect(Math.abs(progressNum - 100) < 0.001);
    setProgress(Math.abs(progressNum - 100) < 0.001 ? "success" : "active");
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };

  const handleSubmit = () => {
    task.plannedProgress.forEach((x, index) => {
      x.expectedProgress = distribution[index];
    });
    task.applyDistribution("Custom");
    handleClose();
  };

  const ProgressColour = (prog, isValid) => {
    if (prog - 100 > 0.01) {
      setCorrect(false);
      return "error";
    } else if (prog - 100 < -0.01) {
      setCorrect(false);
      return "active";
    } else {
      setCorrect(true && isValid);
      return "success";
    }
  };

  const periodInputChangedHandler = (event) => {
    let name = event.target.name;
    let val = event.target.value;
    let progress = 0;
    let isValid = true;
    const index = parseInt(name);

    distribution[index] = val;
    distribution.forEach((x) => {
      if (!isNaN(x) && x !== "") progress += parseFloat(x);
      else {
        isValid = false;
      }
    });
    setTotalProgress(progress);
    setProgress(ProgressColour(progress, isValid));
  };

  const FormOptions = (period, index) => {
    return (
      <NumericFormat
        key={index}
        autoComplete="off"
        step="any"
        error={isNaN(distribution[index])}
        label={"Period " + period}
        id="filled-size-small"
        value={distribution[index]}
        variant="filled"
        size="small"
        name={index.toString()}
        onChange={periodInputChangedHandler}
        thousandSeparator
        isNumericString
        decimalScale={3}
        prefix=""
        customInput={TextField}
      />
    );
  };

  const percentComplete =
    Math.abs(totalProgress - 100) < 0.001 ? 100 : totalProgress;
  const progressInputFields = task.plannedProgress.map((progress, index) =>
    FormOptions(progress.period, index)
  );

  return (
    <div>
      <Button
        style={{ height: "100%", marginLeft: "2px" }}
        size="small"
        variant="contained"
        onClick={handleOpen}
        disabled={!isButtonVisible || !isTask}
      >
        Customize Progress
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        autoCorrect="off"
      >
        <DialogTitle id="form-dialog-title">Progress Distribution</DialogTitle>
        <Alert severity="warning">
          You are overriding the Planned Progress settings
        </Alert>
        <DialogContent>
          <DialogContentText>
            Please enter the progress for each period.
          </DialogContentText>
          {progressInputFields}
          <Progress
            theme={{
              error: {
                symbol: totalProgress,
                color: "#fb3030",
              },
            }}
            percent={percentComplete}
            label={totalProgress}
            status={progress}
          />
        </DialogContent>
        <DialogActions>
          <Button size="medium" variant="contained" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            size="medium"
            variant="contained"
            disabled={!correct}
            onClick={handleSubmit}
            startIcon={<SaveIcon />}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
